import React from 'react';
import './style.css'; 

import img1 from '../../../Assets/developmentKit/1.webp'
import img2 from '../../../Assets/developmentKit/2.webp'
import img3 from '../../../Assets/developmentKit/3.webp'


// import bannerText from '../../../Assets/home/hero_section/banner_text.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Sliders from '../../../Molecules/Sliders';
import ImageLightbox, { useLightbox } from '../ImageLightbox';

import { Button } from "../../../Atoms";
import { useNavigate } from 'react-router-dom';
// import { IoChevronForwardOutline } from 'react-icons/io5';
// import { BsArrowRightShort } from 'react-icons/bs';


const bannerSection = [
  {
    src: img2,
  },
  {
    src: img3,
  },
  {
    src: img1,
  },
  
];
// index.js
export default function Banner() {
  const navigate = useNavigate();
  const lightbox = useLightbox();
  const sliderContainerRef = React.useRef(null);

  const handleSliderClick = (e) => {
    if (!sliderContainerRef.current) return;

    // Ignore clicks on dots/arrows so slider controls still work normally
    if (e.target.closest('.slick-dots') || e.target.closest('.slick-arrow')) {
      return;
    }

    // In fade mode all slides stack at the same position; only the
    // slide react-slick marks .slick-active is the one actually visible.
    const activeImg = sliderContainerRef.current.querySelector('.slick-active img');
    if (activeImg) {
      lightbox.open(activeImg.src);
    }
  };

  return (
    <section className="banner flex bg-light-gradient pb-0 md:pb-28 lg:pb-40 pt-20 md:pt-28 lg:pt-40 my-10 xl:my-0 ">
      <div className="z-10 containers-min mx-auto sm:flex  md:flex-row flex-col sm:items-center ">
        <div className="md:w-6/12 h-fit flex justify-center items-start flex-col min-w-[300px] ">
        <div className="flex items-center gap-3 mb-4">
  <div className="w-1 h-5 bg-[rgb(35,180,85)] rounded-full"></div>
  <span className="text-[rgb(35,180,85)] font-poppins font-semibold text-xs tracking-[1.5px] uppercase">
   Skill Development Kits
  </span>
</div>
          <h1 className="leading-tight !h3 font-gilroylight font-light">
            AC Charger 
            <br />
            <span className="font-gilroybold">Development Kit</span>
            {/* <br /> Think
            <span className="font-gilroybold pl-3">
              VerdeMobility!
            </span> */}
          </h1>
          <h5 className="lg:mt-6 mt-4 font-poppins">
            A hands-on platform to Learn, Experiment, and Understand AC EV Charging.
          </h5>
           
           <Button
            title="Get in Touch"
            onClick={() => navigate('/get-in-touch')}
            className="mt-6"
          />
        </div>

        <div
          className="md:w-5/12 w-full p-4 md:mt-0 mt-10 mx-auto relative lg:min-h-[400px] min-h-[300px]"
          ref={sliderContainerRef}
          onClick={handleSliderClick}
        >
          <Sliders data={bannerSection} classname="lg:min-h-[500px] cursor-zoom-in" settings={{ speed: 800, autoplay: true, autoplaySpeed: 1500 }}/>
        </div>
      </div>
       <ImageLightbox {...lightbox} alt="VerdeMobility banner" />
    </section>
  );
}